export const formatNilai = (value) => {
  if (value) {
    return "Rp. " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  } else {
    return "";
  }
};
